import React from 'react'
import PersonalDataForm from '../components/PersonalDataForm'
import SocialForm from '../components/SocialForm'
import PasswordForm from '../components/PasswordForm'

function ProfileTab({ appleFail, vkFail }) {
  return (
    <>
      <PersonalDataForm />
      <SocialForm {...{ appleFail, vkFail }} />
      <PasswordForm />
    </>
  )
}

export default ProfileTab
